
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[identifier]",
      function () {
        return require("private-next-pages/content/[identifier].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[identifier]"])
      });
    }
  